/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiParkingPlaceCreateParkingPlacePost$Json } from '../fn/parking-place/api-parking-place-create-parking-place-post-json';
import { ApiParkingPlaceCreateParkingPlacePost$Json$Params } from '../fn/parking-place/api-parking-place-create-parking-place-post-json';
import { apiParkingPlaceCreateParkingPlacePost$Plain } from '../fn/parking-place/api-parking-place-create-parking-place-post-plain';
import { ApiParkingPlaceCreateParkingPlacePost$Plain$Params } from '../fn/parking-place/api-parking-place-create-parking-place-post-plain';
import { apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Json } from '../fn/parking-place/api-parking-place-get-parking-place-by-charger-id-and-connector-id-get-json';
import { ApiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Json$Params } from '../fn/parking-place/api-parking-place-get-parking-place-by-charger-id-and-connector-id-get-json';
import { apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Plain } from '../fn/parking-place/api-parking-place-get-parking-place-by-charger-id-and-connector-id-get-plain';
import { ApiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Plain$Params } from '../fn/parking-place/api-parking-place-get-parking-place-by-charger-id-and-connector-id-get-plain';
import { apiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Json } from '../fn/parking-place/api-parking-place-get-parking-place-with-parking-spots-get-json';
import { ApiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Json$Params } from '../fn/parking-place/api-parking-place-get-parking-place-with-parking-spots-get-json';
import { apiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Plain } from '../fn/parking-place/api-parking-place-get-parking-place-with-parking-spots-get-plain';
import { ApiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Plain$Params } from '../fn/parking-place/api-parking-place-get-parking-place-with-parking-spots-get-plain';
import { apiParkingPlaceUpdateParkingPlaceByChargerIdPatch } from '../fn/parking-place/api-parking-place-update-parking-place-by-charger-id-patch';
import { ApiParkingPlaceUpdateParkingPlaceByChargerIdPatch$Params } from '../fn/parking-place/api-parking-place-update-parking-place-by-charger-id-patch';
import { ChardiOverviewDto } from '../models/chardi-overview-dto';
import { ParkingPlace } from '../models/parking-place';

@Injectable({ providedIn: 'root' })
export class ParkingPlaceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiParkingPlaceGetParkingPlaceWithParkingSpotsGet()` */
  static readonly ApiParkingPlaceGetParkingPlaceWithParkingSpotsGetPath = '/api/ParkingPlace/GetParkingPlaceWithParkingSpots';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Plain$Response(params?: ApiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ParkingPlace>> {
    return apiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Plain(params?: ApiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Plain$Params, context?: HttpContext): Observable<ParkingPlace> {
    return this.apiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ParkingPlace>): ParkingPlace => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Json$Response(params?: ApiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ParkingPlace>> {
    return apiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Json(params?: ApiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Json$Params, context?: HttpContext): Observable<ParkingPlace> {
    return this.apiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ParkingPlace>): ParkingPlace => r.body)
    );
  }

  /** Path part for operation `apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet()` */
  static readonly ApiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGetPath = '/api/ParkingPlace/GetParkingPlaceByChargerIdAndConnectorId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Plain$Response(params?: ApiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChardiOverviewDto>> {
    return apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Plain(params?: ApiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Plain$Params, context?: HttpContext): Observable<ChardiOverviewDto> {
    return this.apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChardiOverviewDto>): ChardiOverviewDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Json$Response(params?: ApiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ChardiOverviewDto>> {
    return apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Json(params?: ApiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Json$Params, context?: HttpContext): Observable<ChardiOverviewDto> {
    return this.apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChardiOverviewDto>): ChardiOverviewDto => r.body)
    );
  }

  /** Path part for operation `apiParkingPlaceCreateParkingPlacePost()` */
  static readonly ApiParkingPlaceCreateParkingPlacePostPath = '/api/ParkingPlace/CreateParkingPlace';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiParkingPlaceCreateParkingPlacePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingPlaceCreateParkingPlacePost$Plain$Response(params?: ApiParkingPlaceCreateParkingPlacePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ParkingPlace>> {
    return apiParkingPlaceCreateParkingPlacePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiParkingPlaceCreateParkingPlacePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingPlaceCreateParkingPlacePost$Plain(params?: ApiParkingPlaceCreateParkingPlacePost$Plain$Params, context?: HttpContext): Observable<ParkingPlace> {
    return this.apiParkingPlaceCreateParkingPlacePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ParkingPlace>): ParkingPlace => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiParkingPlaceCreateParkingPlacePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingPlaceCreateParkingPlacePost$Json$Response(params?: ApiParkingPlaceCreateParkingPlacePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ParkingPlace>> {
    return apiParkingPlaceCreateParkingPlacePost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiParkingPlaceCreateParkingPlacePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingPlaceCreateParkingPlacePost$Json(params?: ApiParkingPlaceCreateParkingPlacePost$Json$Params, context?: HttpContext): Observable<ParkingPlace> {
    return this.apiParkingPlaceCreateParkingPlacePost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ParkingPlace>): ParkingPlace => r.body)
    );
  }

  /** Path part for operation `apiParkingPlaceUpdateParkingPlaceByChargerIdPatch()` */
  static readonly ApiParkingPlaceUpdateParkingPlaceByChargerIdPatchPath = '/api/ParkingPlace/UpdateParkingPlaceByChargerId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiParkingPlaceUpdateParkingPlaceByChargerIdPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingPlaceUpdateParkingPlaceByChargerIdPatch$Response(params?: ApiParkingPlaceUpdateParkingPlaceByChargerIdPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiParkingPlaceUpdateParkingPlaceByChargerIdPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiParkingPlaceUpdateParkingPlaceByChargerIdPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiParkingPlaceUpdateParkingPlaceByChargerIdPatch(params?: ApiParkingPlaceUpdateParkingPlaceByChargerIdPatch$Params, context?: HttpContext): Observable<void> {
    return this.apiParkingPlaceUpdateParkingPlaceByChargerIdPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
